import React from "react";
import { usePermission } from "../../context/PermissionContext";

interface ActionGuardProps {
  module: string;
  action?: string;
  children: React.ReactNode;
}

const ActionGuard: React.FC<ActionGuardProps> = ({ module, action, children }) => {
  const { hasPermission } = usePermission();

  if (!hasPermission(module, action)) {
    return null;
  }

  return <>{children}</>;
};

export default ActionGuard;
